export const isFullStatic = false
export const staticPath = "/home/vsts/work/1/a/NuxtApp/.nuxt/static-json"
export const publicPath = "/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"